import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartUwCirculaireReis() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="24900" id="klaar-voor-groei" ref={ref} className="text-primary-foreground py-20 transition-all duration-1000 ease-out translate-y-0 !opacity-[1] bg-linear-to-b from-[#fff9f6] to-white md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto bg-[#080c16] rounded-2xl shadow-xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 text-left">
          <div className="flex-1">
            <h2 className="text-4xl font-default font-bold leading-tight tracking-tighter mb-4 !text-[hsl(250,75%,67%)] md:text-5xl">
              Klaar om te connecten?
            </h2>
            <p className="text-lg text-white/70 font-default max-w-md leading-relaxed">
              De ondernemers die vandaag de stap zetten, lopen morgen voor. Jouw online podium wacht. Ben jij er klaar voor?
            </p>
          </div>

          <div className="flex flex-col items-start gap-4 w-full md:w-72">
            <Button asChild size="lg" className="w-full bg-white text-[#080c16] hover:bg-white/90 font-default font-semibold text-lg h-14 shadow-xl border-none rounded-lg">
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive px-6 has-[>svg]:px-4 w-full text-[#080c16] font-default font-semibold text-lg h-14 shadow-xl border-none rounded-lg !bg-[hsl(250,75%,67%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-white/90">
                <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                Plan een gesprek
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full bg-transparent border-2 border-white/20 text-white hover:bg-white hover:text-[#080c16] font-default font-semibold text-lg h-14 transition-all rounded-lg">
              <Link to="/diensten">
                <ArrowRight className="mr-2 h-5 w-5" />
                Bekijk onze diensten
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}